import {Component, signal, ChangeDetectionStrategy} from "@angular/core"
import {BaseInspectorComponent} from "@app/template-editor/components/inspectors/base-inspector/base-inspector.component"
import {InspectorSectionComponent} from "@app/template-editor/components/inspectors/inspector-section/inspector-section.component"
import {SelectionPossibilities, ValueSlotComponent} from "@app/template-editor/components/value-slot/value-slot.component"
import {TransformToValue} from "@cm/template-nodes"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-transform-to-value-inspector",
    templateUrl: "./transform-to-value-inspector.component.html",
    styleUrl: "./transform-to-value-inspector.component.scss",
    imports: [InspectorSectionComponent, ValueSlotComponent],
})
export class TransformToValueInspectorComponent extends BaseInspectorComponent<TransformToValue> {
    readonly $valueTypePossibilities = signal<SelectionPossibilities<TransformToValue["parameters"]["valueType"]>>([
        {value: "positionX", name: "Position X"},
        {value: "positionY", name: "Position Y"},
        {value: "positionZ", name: "Position Z"},
        {value: "rotationX", name: "Rotation X"},
        {value: "rotationY", name: "Rotation Y"},
        {value: "rotationZ", name: "Rotation Z"},
    ])
}
